// @core/api/endpoints/landing/get_landing_page_by_slug.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LandingPageResponse,
} from '../../../types/landing';

const BASE_PATH = '/landing';

/**
 * Get landing page by slug
 * Retrieves a published landing page by its URL slug. Public endpoint for page rendering.
 * @public This endpoint does not require authentication
 */
export async function GetLandingPageBySlug(
  slug: string,
  options?: RequestOptions
): Promise<LandingPageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/l/:slug`;
  requestPath = requestPath.replace(':slug', encodeURIComponent(slug));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<LandingPageResponse>(requestPath, { ...requestOptions });
}
